export interface User {
  uid: string;
  displayName: string;
  email: string;
  emailVerified: boolean;
  token: string;
  provider: string;
  companies?: Array<{
    id: string;
    name: string;
    status: string;
  }>;
}

export const KEY_TOKEN = `token`;
export const KEY_AUTH_USER = `auth-user`;
export const KEY_COMPANY_ID = `company`;
